import {ResolveFn} from '@angular/router';
import {inject} from "@angular/core";
import {ApiService} from "@app/_services/api.service";
import {forkJoin} from "rxjs";

export const ediSenderReceiversResolver: ResolveFn<any> = (route, state) => {
    const apiService = inject(ApiService);
    return forkJoin({
        data: apiService.getEdiValidSenderReceivers(),
        partners: apiService.getEdiPartnerMappings(),
        customers: apiService.getCustomers()
    });
};
